import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,       // 30s — data is "fresh" for this long
      gcTime: 5 * 60_000,      // 5min — unused data stays in cache
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
